// extracted by mini-css-extract-plugin
module.exports = {"form":"form___235aO"};